module.exports = __webpack_public_path__ + "media/images/icons/msg-770302560e8a861f99a00700b964b80b.svg";